/** @module components/ProFooter */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Icon, Alert } from "@devowl-wp/react-folder-tree";
import { request, rmlOpts, i18n, getMediaDialogNextZIndex } from "../util";
import { Modal } from ".";
import T from "i18n-react";
/**
 * Show a dialog box with a pro feature.
 *
 * @param [props.feature=undefined] {string} The feature to show
 * @extends React.Component
 */ class ProBox extends React.Component {
    constructor(props){
        super(props);
        this.redirect = ()=>{
            window.open(`${rmlOpts.others.proUrl}&feature=${this.props.feature}`, "_blank").focus();
            this.props.onClose();
        };
    }
    render() {
        let title;
        let modalContent;
        const { feature } = this.props;
        if (feature) {
            const set = rmlOpts.others.lang.proFeatures[feature];
            title = /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "lock"
                    }),
                    " ",
                    set.title,
                    " ",
                    rmlOpts.others.lang.proBoxTitle
                ]
            });
            modalContent = /*#__PURE__*/ _jsxs("div", {
                children: [
                    !!set.image && /*#__PURE__*/ _jsx("img", {
                        src: `https://assets.devowl.io/in-app/wp-real-media-library/${set.image}`
                    }),
                    /*#__PURE__*/ _jsx(T.p, {
                        text: set.description
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsx(Modal, {
            visible: !!modalContent,
            title: title,
            onOk: this.redirect,
            onCancel: this.props.onClose,
            cancelText: i18n("proBoxCancel"),
            okText: i18n("proBoxOk"),
            zIndex: getMediaDialogNextZIndex(),
            className: "rml-probox",
            children: modalContent
        });
    }
}
async function dismiss() {
    await request({
        location: {
            path: "/notice/lite",
            method: "DELETE"
        }
    });
    window.location.reload();
}
const ProFooter = (param)=>{
    let { dismissible = false, feature } = param;
    return /*#__PURE__*/ _jsx(Alert, {
        message: /*#__PURE__*/ _jsxs("span", {
            children: [
                rmlOpts.others.lang.proFooterText,
                " \xb7",
                " ",
                /*#__PURE__*/ _jsx("a", {
                    href: `${rmlOpts.others.proUrl}&feature=${feature}`,
                    target: "_blank",
                    rel: "noreferrer",
                    children: rmlOpts.others.lang.proLearnMore
                }),
                dismissible && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        " ",
                        "\xb7",
                        " ",
                        /*#__PURE__*/ _jsx("a", {
                            onClick: dismiss,
                            href: "#",
                            children: rmlOpts.others.lang.proDismiss
                        })
                    ]
                })
            ]
        }),
        type: "info",
        style: {
            marginBottom: "10px"
        }
    });
};
export { ProFooter, ProBox };
